import type { SkillDefinition } from '../domain/types';
import { VANGUARD_PERMANENT_ACTIVES } from './vanguardActives';

/**
 * Milestone 3 provisional primary-dice skills.
 * Used as dungeon-offer fallback only when no permanent actives are unlocked.
 * Values are provisional placeholders (OPEN: balance).
 */
export const VANGUARD_PROVISIONAL_PRIMARY_SKILLS: readonly SkillDefinition[] = [
  {
    id: 'crushing_blow',
    name: 'Crushing Blow',
    description: 'Deal bonus physical damage to the target.',
    classId: 'vanguard',
    kind: 'primary_dice',
    category: 'damage',
    maxLevel: 5,
    effect: { type: 'damage', baseAmount: 4, perLevel: 2 },
  },
  {
    id: 'iron_guard',
    name: 'Iron Guard',
    description: 'Gain a temporary shield.',
    classId: 'vanguard',
    kind: 'primary_dice',
    category: 'defence',
    maxLevel: 5,
    effect: { type: 'shield', baseAmount: 3, perLevel: 1 },
  },
  {
    id: 'rending_strike',
    name: 'Rending Strike',
    description: 'Apply Bleed to the target.',
    classId: 'vanguard',
    kind: 'primary_dice',
    category: 'status',
    maxLevel: 5,
    effect: {
      type: 'status',
      statusId: 'bleed',
      baseIntensity: 2,
      perLevel: 1,
      durationTurns: 3,
    },
  },
  {
    id: 'stunning_bash',
    name: 'Stunning Bash',
    description: 'Deal light damage and Stun the target.',
    classId: 'vanguard',
    kind: 'primary_dice',
    category: 'status',
    maxLevel: 5,
    effect: {
      type: 'damage_and_status',
      baseDamage: 2,
      damagePerLevel: 1,
      statusId: 'stun',
      baseIntensity: 1,
      intensityPerLevel: 0,
      durationTurns: 1,
    },
  },
  {
    id: 'shield_bash',
    name: 'Shield Bash',
    description: 'Deal damage and gain a small shield.',
    classId: 'vanguard',
    kind: 'primary_dice',
    category: 'damage',
    maxLevel: 5,
    effect: {
      type: 'damage_and_shield',
      baseDamage: 3,
      damagePerLevel: 1,
      baseShield: 2,
      shieldPerLevel: 1,
    },
  },
  {
    id: 'bulwark',
    name: 'Bulwark',
    description: 'Strong shield for the hero.',
    classId: 'vanguard',
    kind: 'primary_dice',
    category: 'defence',
    maxLevel: 5,
    effect: { type: 'shield', baseAmount: 5, perLevel: 2 },
  },
] as const;

/** @deprecated Prefer VANGUARD_PROVISIONAL_PRIMARY_SKILLS or unlocked permanent actives. */
export const VANGUARD_PRIMARY_SKILLS = VANGUARD_PROVISIONAL_PRIMARY_SKILLS;

export const SKILL_BY_ID: Readonly<Record<string, SkillDefinition>> =
  Object.fromEntries(
    [...VANGUARD_PROVISIONAL_PRIMARY_SKILLS, ...VANGUARD_PERMANENT_ACTIVES].map(
      (s) => [s.id, s],
    ),
  );

/** Provisional XP awarded when an enemy is defeated. OPEN: loot/XP curves. */
export const ENEMY_XP_REWARD: Readonly<Record<string, number>> = {
  slime: 12,
  goblin: 15,
  bat: 8,
  cave_brute: 45,
};
